import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { useGetAllPhonecentersSysModelsList } from "../../Parameters/PhoneCenters/PhonecentersSysModels/api/getAllPhonecentersSysModelsList";
import { useGetAllPhonecentersMaintenancesList } from "../../Parameters/PhoneCenters/PhonecentersMaintenance/api/getAllPhonecentersMaintenanceList";
import { StyledInputSearchFormik } from "src/components/Common/UI/MultipleSelectBox/FormStyles";
import { useGetAllProvidersList } from "../../Parameters/Others/Providers/api/getAllProvidersList";
import { ISearchDropdown } from "src/components/Common/UI/MultipleSelectBox/MultipleSelectBoxFormik";
import { ICreatePhoneCenterForm, IEditPhoneCenterForm } from "./phoneCenter";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";



const PhoneCenterForm = ({ type, initialValues, onSubmit }: PhoneCenterFormProps) => {
  const { t } = useTranslation();
  const getAllPhonecentersSysModelsListQuery = useGetAllPhonecentersSysModelsList({});
  const getAllPhonecentersMaintenancesListQuery = useGetAllPhonecentersMaintenancesList({});
  const getAllProvidersListQuery = useGetAllProvidersList({});

  const convertProvidersToSearchDropdown = (
    internalList: IGetProvider[] | undefined
  ): ISearchDropdown[] => {
    let dropdownList: ISearchDropdown[] = [];
  
    if (internalList && Array.isArray(internalList)) {
      dropdownList = internalList.map((i) => ({
        label: i.description?.toString() || '',
        value: i.id?.toString() || '',
      }));
    }
  
    return dropdownList;
  };

  const unitlab: { value: string, label: string }[] = [
    { value: '', label: 'Επιλέξτε είδος μονάδας' },
    { value: 'est', label: 'Καταστήματα' },
    { value: 'dep', label: 'Διευθύνσεις' },
    { value: 'dco', label: 'Θυγατρικές' },
    { value: 'sma', label: 'Σουπερμάρκετ' },
    { value: 'uni', label: 'Μονάδες' }
  ];

  const validationSchema= Yup.object({
    description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),

  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        if (type === "create") {
          onSubmit(values, formikHelpers);
        } else {
          onSubmit(
            values, formikHelpers
          );
        }
      }}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, setFieldValue }) => (
        <Form>
          <Container fluid className="p-0">
          <Row>
            <Col xs={6}>
                <label className="form-label">
                  {`${t("Περιγραφή Γραμμής")}*`}
                </label>
                <Field
                  name="description"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="description"
                 
                />
                <div className="text-danger">
                  {errors.description && touched.description && (
                    <div>{errors.description}</div>
                  )}
                </div>
              </Col>

              <UnitsSelectionDropdown errors={errors} touched={touched} />
              
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Μοντέλο")}*`}
                </label>
                <Field
                  as="select"
                  name="phoneCentersSysModelId"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="phoneCentersSysModelId"
                >
                <option value="">{t("Επιλέξτε Μοντέλο")}</option>
                {getAllPhonecentersSysModelsListQuery.data &&
                  getAllPhonecentersSysModelsListQuery.data.map((model) => (
                    <option key={model.id} value={model.id}>
                      {model.description}
                    </option>
                  ))}    
                    
              </Field>
                <div className="text-danger">
                  {errors.phoneCentersSysModelId && touched.phoneCentersSysModelId && (
                    <div>{errors.phoneCentersSysModelId}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Συντήρηση")}*`}
                </label>
                <Field
                  as="select"
                  name="phoneCentersMaintenanceId"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="phoneCentersMaintenanceId"
                >
                <option value="">{t("Επιλέξτε Συντήρηση")}</option>
                {getAllPhonecentersMaintenancesListQuery.data &&
                  getAllPhonecentersMaintenancesListQuery.data.map((maintenance) => (
                    <option key={maintenance.id} value={maintenance.id}>
                      {maintenance.description}
                    </option>
                  ))}    
                    
              </Field>
                <div className="text-danger">
                  {errors.phoneCentersMaintenanceId && touched.phoneCentersMaintenanceId && (
                    <div>{errors.phoneCentersMaintenanceId}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εξ. Γραμμές")}*`}
                </label>
                <Field
                  name="incomingLines"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="incomingLines"
                 
                />
                <div className="text-danger">
                  {errors.incomingLines && touched.incomingLines && (
                    <div>{errors.incomingLines}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εσ. Γραμμές")}*`}
                </label>
                <Field
                  name="outgoingLines"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="outgoingLines"
                 
                />
                <div className="text-danger">
                  {errors.outgoingLines && touched.outgoingLines && (
                    <div>{errors.outgoingLines}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <StyledInputSearchFormik 
                label="Πάροχοι" 
                errorName="Πάροχοι" 
                defaultValues={convertProvidersToSearchDropdown(getAllProvidersListQuery.data)}
                selectedValues={values.providers}
                name={"providers"}                       
                />
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός channel")}*`}
                </label>
                <Field
                  name="channelNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="channelNumber"
                 
                />
                <div className="text-danger">
                  {errors.channelNumber && touched.channelNumber && (
                    <div>{errors.channelNumber}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Workstaions")}*`}
                </label>
                <Field
                  name="workstaions"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="workstaions"
                 
                />
                <div className="text-danger">
                  {errors.workstaions && touched.workstaions && (
                    <div>{errors.workstaions}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Aνελκυστήρας πλήθος")}*`}
                </label>
                <Field
                  name="elevatorNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="elevatorNumber"
                 
                />
                <div className="text-danger">
                  {errors.elevatorNumber && touched.elevatorNumber && (
                    <div>{errors.elevatorNumber}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("FCT πλήθος")}*`}
                </label>
                <Field
                  name="fctNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="fctNumber"
                 
                />
                <div className="text-danger">
                  {errors.fctNumber && touched.fctNumber && (
                    <div>{errors.fctNumber}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Κωδικός Βλάβης")}*`}
                </label>
                <Field
                  name="errorCode"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="errorCode"
                 
                />
                <div className="text-danger">
                  {errors.errorCode && touched.errorCode && (
                    <div>{errors.errorCode}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εσωτερική επικοινωνία πλήθος")}*`}
                </label>
                <Field
                  name="internalsNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="internalsNumber"
                 
                />
                <div className="text-danger">
                  {errors.internalsNumber && touched.internalsNumber && (
                    <div>{errors.internalsNumber}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Σχόλια")}*`}
                </label>
                <Field
                  name="comments"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="comments"
                 
                />
                <div className="text-danger">
                  {errors.comments && touched.comments && (
                    <div>{errors.comments}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("fileLink")}*`}
                </label>
                <Field
                  name="fileLink"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="fileLink"
                 
                />
                <div className="text-danger">
                  {errors.fileLink && touched.fileLink && (
                    <div>{errors.fileLink}</div>
                  )}
                </div>
              </Col>



              <Row>
                <Col xs={12}>
                  <label className="form-label">
                    {`${t("Τύπος Γραμμών")}:`}
                  </label>

                  <div style={{ display: 'inline-block', marginLeft: '10px' }}>
                    <label className="form-label">
                      {`${t("isPSTN")}*`}
                    </label>
                    <Field
                      type="checkbox"
                      name="isPSTN"
                      field="isPSTN"
                      className="mt-3 mb-3"
                    />
                    <div className="text-danger">
                      {errors.isPSTN && touched.isPSTN && (
                        <div>{errors.isPSTN}</div>
                      )}
                    </div>
                  </div>

                  <div style={{ display: 'inline-block', marginLeft: '10px' }}>
                    <label className="form-label">
                      {`${t("ISDN")}*`}
                    </label>
                    <Field
                      type="checkbox"
                      name="isISDN"
                      field="isISDN"
                      className="mt-3 mb-3"
                    />
                    <div className="text-danger">
                      {errors.isISDN && touched.isISDN && (
                        <div>{errors.isISDN}</div>
                      )}
                    </div>
                  </div>

                  <div style={{ display: 'inline-block', marginLeft: '10px' }}>
                    <label className="form-label">
                      {`${t("30PRI")}*`}
                    </label>
                    <Field
                      type="checkbox"
                      name="is30PRI"
                      field="is30PRI"
                      className="mt-3 mb-3"
                    />
                    <div className="text-danger">
                      {errors.is30PRI && touched.is30PRI && (
                        <div>{errors.is30PRI}</div>
                      )}
                    </div>
                  </div>

                  <div style={{ display: 'inline-block', marginLeft: '10px' }}>
                    <label className="form-label">
                      {`${t("Line")}*`}
                    </label>
                    <Field
                      type="checkbox"
                      name="isLine"
                      field="isLine"
                      className="mt-3 mb-3"
                    />
                    <div className="text-danger">
                      {errors.isLine && touched.isLine && (
                        <div>{errors.isLine}</div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              
            
            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
            </Button>
          </div>
        </Form>
    )}
    </Formik>
)
}
export default PhoneCenterForm;

type CreateOrEdit =
  | {
      type: "create";
      initialValues: ICreatePhoneCenterForm;
      onSubmit: (
        values: ICreatePhoneCenterForm,
        formikHelpers: FormikHelpers<ICreatePhoneCenterForm>
      ) => void;
    }
  | {
      type: "edit";
      initialValues: IEditPhoneCenterForm;
      onSubmit: (
        values: IEditPhoneCenterForm,
        formikHelpers: FormikHelpers<IEditPhoneCenterForm>
      ) => void;
    };

type PhoneCenterFormProps = CreateOrEdit;